import logo from 'assets/images/groceryLogo.png';
const LogoIcon = () => {

  return (
    <img src={logo} alt="icon logo" style={{width:'70px', marginTop:'15px'}} />
  );
};

export default LogoIcon;
